import React from 'react';

import PageHeaderTile from '../ui/PageHeaderTile';
import { Repeat } from 'lucide-react';
import NewAutomaticInvoiceForm from '../new-automatic-invoices/NewAutomaticInvoiceForm';
import AutomaticInvoicesList from '../new-automatic-invoices/AutomaticInvoicesList';
import { useBankDetails } from '../../hooks/useBankDetails';
import { useRecurringInvoices } from '../../hooks/useRecurringInvoices';
import { useInvoiceForm } from '../../hooks/useInvoiceForm';
import { useClientSearch } from '../../hooks/useClientSearch';
import LoadingOverlay from '../ui/LoadingOverlay';

function RecurringPage(props) {
    const bankDetails = useBankDetails();
    const { suggestions, showSuggestions, searchClients, clearSuggestions } = useClientSearch();
    const {
        invoices: recurringInvoices,
        sorting,
        setSorting,
        page,
        setPage,
        totalPages,
        totalElements,
        size,
        setSize,
        filters,
        setFilters,
        isLoading,
        createInvoice,
        updateInvoice,
        deleteInvoice
    } = useRecurringInvoices(20);

    const {
        formData,
        items,
        handleInputChange,
        handleItemInputChange,
        addItemDiv,
        removeItemDiv,
        handleLoadInvoiceToForm,
    } = useInvoiceForm();

    const handleSubmit = async (e) => {
        e.preventDefault();
        await createInvoice(formData);
    };

    return (
        <div className="w-full max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8 flex flex-col gap-8">
            <LoadingOverlay isVisible={isLoading} message="Обработка на заявката..." />
            <PageHeaderTile title="Автоматични фактури" icon={Repeat} />
            <NewAutomaticInvoiceForm
                formData={formData}
                items={items}
                bankDetails={bankDetails}
                addItemDiv={addItemDiv}
                removeItemDiv={removeItemDiv}
                handleInputChange={handleInputChange}
                handleItemInputChange={handleItemInputChange}
                handleRecurringInvoiceSubmit={handleSubmit}
                searchClients={searchClients}
                suggestions={suggestions}
                showSuggestions={showSuggestions}
                clearSuggestions={clearSuggestions}
            />
            <AutomaticInvoicesList
                invoices={recurringInvoices}
                handleDeleteRecurringInvoice={deleteInvoice}
                handleLoadInvoiceToForm={handleLoadInvoiceToForm}
                handleUpdateRecurringInvoice={updateInvoice}
                sorting={sorting}
                setSorting={setSorting}
                page={page}
                setPage={setPage}
                totalPages={totalPages}
                totalElements={totalElements}
                size={size}
                setSize={setSize}
                filters={filters}
                setFilters={setFilters}
            />
        </div>
    );
}

export default RecurringPage;
